<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__title">综合管理</div>
    </div>
    <div class="page-panel__body">
      <el-tabs v-model="activeName">
        <el-tab-pane label="banner管理" name="banner管理">
          <banner v-if="activeName=='banner管理'"></banner>
        </el-tab-pane>
        <!-- <el-tab-pane label="header管理" name="header管理"></el-tab-pane>
        <el-tab-pane label="footer管理" name="footer管理"></el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import banner from './banner';
export default {
  data() {
    return {
      activeName: 'banner管理'
    };
  },
  components: {
    banner
  },
  methods: {
    add() {
      this.$router.push({
        path: '/admin/article/add'
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/comprehensive/index.vue